export default "__VITE_ASSET__COF42YTb__"